import { Badge, ArrowIcon } from '@cmsgov/ds-medicare-gov'
import { Button } from 'components/Button/Button'
import classNames from 'classnames'
import { useRef } from 'react'

interface MobileNavOptionProps {
  onClick?: () => void;
  label: string;
  labelHasPotentialPii?: boolean;
  lang?: 'es' | 'en';
  noCaret: boolean;
  href?: string;
  icon?: string;
  unreadMessageCount?: number;
}

export const MobileNavOption: React.FC<MobileNavOptionProps> = ({ href, onClick, label, noCaret, icon, unreadMessageCount, lang, labelHasPotentialPii }) => {
  const ref = useRef<HTMLAnchorElement | HTMLButtonElement>(null)
  const buttonClassName = classNames(
    'nav-menu-button ch-u-width--full ds-u-font-size--base ch-u-hover-text-decoration--underline ch-u-font--rubik',
    // 'ch-c-button ch-c-link ds-u-color--primary ds-u-text-decoration--none ch-c-mobile-nav__option-btn',
    labelHasPotentialPii ? 'qm-block-pii' : undefined
  )
  return (
    <Button
      href={href}
      className={buttonClassName}
      ref={ref}
      lang={lang}
      onClick={() => {
        if (ref.current) {
          ref.current.focus()
        }
        if (onClick) onClick()
      }}
    >
      <div className='ds-u-display--flex ds-u-justify-content--between ch-u-width--full'>
        <span className='ds-u-display--flex ds-u-align-items--center ds-u-justify-content--center'>
          {icon && <img className='ch-u-margin-right--8px' src={icon} alt='' />}
          <span className='ch-u-height--20 ch-u-mr--3'>{label}</span>
          {(unreadMessageCount && unreadMessageCount > 0) ? <Badge className='ch-c-badge ch-c-badge__orange' variation='warn'>{unreadMessageCount}</Badge> : ''}
        </span>
        {!noCaret && <span><ArrowIcon ariaHidden direction='right' /></span>}
      </div>
    </Button>
  )
}
